// src/api/admin.js
import api from './axios';

// 게시판 그룹 API
export const getBoardGroups = () => api.get('/api/boards/groups/');
export const createBoardGroup = (d) => api.post('/api/boards/groups/create/', d);
export const editBoardGroup = (id, d) => api.put(`/api/boards/groups/${id}/update/`, d);
export const deleteBoardGroup = (id) => api.post(`/api/boards/groups/${id}/delete/`);
export const moveBoardGroup = (id, dir) =>
    api.post(`/api/boards/groups/${id}/move/`, { direction: dir });



/* ======================================================
 *  📋 게시판(카테고리)
 * ==================================================== */
export const getBoardCategories = () => api.get('/api/boards/categories/');
export const createCategory = (d) => api.post('/api/boards/categories/create/', d);
export const editCategory = (id, d) => api.put(`/api/boards/categories/${id}/update/`, d);
export const deleteCategory = (id) => api.post(`/api/boards/categories/${id}/delete/`);
export const moveCategory = (id, dir) => api.post(
    `/api/boards/categories/${id}/move/`,                   // dir: "up" | "down"
    { direction: dir },
    { headers: { 'Content-Type': 'application/json' } }         // ← JSON 강제
);

/* 옛 API 유지 */
export const fetchCategories = () => api.get('/api/boards/categories/');


/* ======================================================
 *  🗣️ 채팅 카테고리
 * ==================================================== */
export const fetchChatCategories = () => api.get('/api/chat/categories/');
export const createChatCategory = (d) => api.post('/api/chat/categories/create/', d);
export const editChatCategory = (id, d) => api.put(`/api/chat/categories/${id}/update/`, d);
export const deleteChatCategory = (id) => api.delete(`/api/chat/categories/${id}/delete/`);
export const moveChatCategory = (id, dir) => api.post(
    `/api/chat/categories/${id}/move/`,                    // dir: "up" | "down"
    { direction: dir },
    { headers: { 'Content-Type': 'application/json' } }        // ← JSON 강제
);


/* ======================================================
 *  🏷️ 관리자용 채팅방(실채널)
 * ==================================================== */
export const fetchAdminChatRooms = () => api.get('/api/chat/rooms/admin/');
export const deleteChatRoom = (id) => api.delete(`/api/chat/rooms/${id}/delete/`);
export const createChatRoom = (d) => api.post('/api/chat/rooms/create/', d);
